import {GOOGLE_ANALYTICS_EVENTS, HUBSPOT} from './constants';
import isHubspotForm from './utils/isHubspotForm';

const getFormSubmitElement = form => form.querySelector(['button', 'input[type="submit"]']);

export const hubspotFormSubmitCallback = ({target: form, submitter}) => {
  if ((!form) instanceof HTMLFormElement) return;

  const {formId} = form.dataset;
  const submitElement = submitter || getFormSubmitElement(form);
  const clickText = submitElement?.value ?? '';

  window.dataLayer.push({
    event: GOOGLE_ANALYTICS_EVENTS.FORM_SUBMIT,
    form_id: formId || '',
    form_host: HUBSPOT,
    click_text: clickText,
  });
};

const registerHubspotFormSubmit = form => {
  if (!isHubspotForm(form)) return;

  form.addEventListener('submit', hubspotFormSubmitCallback);
};

export default registerHubspotFormSubmit;
